var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "selfordering-login" },
    [
      !_vm.isLoggedIn
        ? [
            _c("FormLogin", {
              ref: "loginForm",
              on: { loggedIn: _vm.onLoggedIn }
            }),
            _vm._v(" "),
            _c("FormRegister", { ref: "registerForm", attrs: { phone: "" } })
          ]
        : _vm.showPhoneForm
        ? [
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("account.selfordering.addPhoneTitle"))
              }
            }),
            _vm._v(" "),
            _c("p", {
              domProps: {
                innerHTML: _vm._s(_vm.$t("account.selfordering.addPhoneText"))
              }
            }),
            _vm._v(" "),
            _c("ValidationObserver", {
              ref: "phoneForm",
              attrs: { tag: "form", novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onPhoneUpdate.apply(null, arguments)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(ref) {
                    var invalid = ref.invalid
                    var errors = ref.errors
                    return [
                      _vm.phoneResponse.message
                        ? _c("GeneralMessage", {
                            attrs: {
                              message: _vm.phoneResponse.message,
                              type: _vm.phoneResponse.type
                            },
                            on: {
                              close: function($event) {
                                _vm.phoneResponse.message = ""
                              }
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ValidationProvider", {
                        staticClass: "input-wrapper",
                        attrs: {
                          name: "phone",
                          rules: "required|phone",
                          tag: "div",
                          customMessages: {
                            required: _vm.$t("forms.errors.fieldEmpty"),
                            phone: _vm.$t("forms.errors.phone")
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                var invalid = ref.invalid
                                var validated = ref.validated
                                return [
                                  _c("FormInput", {
                                    attrs: {
                                      type: "tel",
                                      placeholder: _vm.$t("forms.labels.phone"),
                                      label: _vm.$t("forms.labels.phone"),
                                      error: errors.length > 0,
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.phoneForm.phoneNumber,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.phoneForm,
                                          "phoneNumber",
                                          $$v
                                        )
                                      },
                                      expression: "phoneForm.phoneNumber"
                                    }
                                  }),
                                  _vm._v(" "),
                                  invalid && validated
                                    ? _c("span", {
                                        staticClass: "input-error",
                                        domProps: {
                                          innerHTML: _vm._s(errors[0])
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", {
                                    staticClass: "additional-info",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$t("login.phoneHint")
                                      )
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      }),
                      _vm._v(" "),
                      _c("Button", {
                        attrs: {
                          type: "submit",
                          level: "primary",
                          text: _vm.$t("account.safeButton")
                        }
                      })
                    ]
                  }
                }
              ])
            })
          ]
        : _c(
            "div",
            { staticClass: "selfordering-login__details" },
            [
              _c("h2", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("account.selfordering.qrcodeTitle"))
                }
              }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("account.selfordering.qrcodeText"))
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "selfordering-login__user" },
                [
                  _c("div", {
                    directives: [
                      {
                        name: "sanitize",
                        rawName: "v-sanitize",
                        value:
                          _vm.accountUserDetail.firstName +
                          " " +
                          _vm.accountUserDetail.lastName,
                        expression:
                          "`${accountUserDetail.firstName} ${accountUserDetail.lastName}`"
                      }
                    ],
                    staticClass: "selfordering-login__user-name"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "sanitize",
                        rawName: "v-sanitize",
                        value: _vm.accountUserDetail.email,
                        expression: "accountUserDetail.email"
                      }
                    ],
                    staticClass: "selfordering-login__user-email"
                  }),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "sanitize",
                        rawName: "v-sanitize",
                        value: _vm.accountUserDetail.phoneNumber,
                        expression: "accountUserDetail.phoneNumber"
                      }
                    ],
                    staticClass: "selfordering-login__user-phone"
                  }),
                  _vm._v(" "),
                  _c("Button", {
                    attrs: {
                      level: "tertiary",
                      type: "button",
                      text: _vm.$t("account.selfordering.changePhoneButton"),
                      arrow: ""
                    },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.onPhoneChange.apply(null, arguments)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("QRCode", { attrs: { content: _vm.accountQrTokenPrefixed } }),
              _vm._v(" "),
              _c("SVGScanIllustrationPhone")
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }